module.exports = require('../../modules/_wks-ext').f('toPrimitive');



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/fn/symbol/to-primitive.js